import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@wz-services';

@Component({
  selector: 'wz-mentions-legales-et-cgu',
  templateUrl: './mentions-legales-et-cgu.component.html',
  styleUrls: ['./mentions-legales-et-cgu.component.scss'],
  standalone: false,
})
export class MentionsLegalesEtCguComponent implements OnInit {
  loading: boolean = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }
}
